const matches = require('dom-matches');

var $tmp;

export default {
    matches,
    create(html) {
        var $node;

        if (!$tmp) $tmp = document.createElement('div');

        $tmp.innerHTML = html;
        $node = $tmp.firstChild;
        $tmp.removeChild($node);

        return $node;
    },
    closest(node, exp) {
        do {
            if (matches(node, exp)) return node
        } while (node && (node = node.parentNode))

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/lib/dom.js